import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { EmployeesState } from "@reducers/types/HRM/employees-state";

import { getEmployeesRequest } from "@actions/HRM/employees/employees-actions";
import { getEmployeesState } from "@selectors/HRM/employees/employees-selector";

import { useAppSelector } from "@helpers/redux";

import { EmployeeType, EmployeesResponseType } from "@type/HRM/employees";
import { PaginationType } from "@type/HRM/pagination";

interface UseEmployees {
  employeeRequest: boolean;
  employeeSuccess: boolean;
  employeeFailed: boolean;
  employees: EmployeeType[];
  pagination: PaginationType;
  handleQuery: ({
    officeId,
    positionId,
    unitId,
  }: {
    positionId: number;
    unitId: number;
    officeId: number;
  }) => void;
}

export const useEmployeesForReset = (): UseEmployees => {
  const [query, setQuery] = useState({
    page: 1,
    size: 100000,
    flowStatusId: 88,
  });

  const handleQuery = ({
    officeId,
    positionId,
    unitId,
  }: {
    positionId: number;
    unitId: number;
    officeId: number;
  }) =>
    setQuery((prev) => ({
      ...prev,
      officeId,
      positionId,
      unitId,
    }));

  const getEmployees = useAppSelector<EmployeesState>(getEmployeesState);

  const employeeRequest = getEmployees.request as boolean;
  const employeeSuccess = getEmployees.success as boolean;
  const employeeFailed = getEmployees.failed as boolean;
  const { data: employees, pagination } = getEmployees.data
    ? getEmployees.data
    : ({} as EmployeesResponseType);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEmployeesRequest(query));
  }, [dispatch, query]);

  return {
    handleQuery,
    employeeRequest,
    employeeSuccess,
    employeeFailed,
    employees,
    pagination,
  };
};
